import {makeAutoObservable, runInAction} from 'mobx';
import {Inventory, InventoryItemsName, InventoryLimit} from "@/entities/inventory/types";
import {fetchInventory, fetchInventoryLimits} from "@/shared/api/api";
import {RootStore} from "@/app/providers/StoreProvider";
import {GameChangeEvent} from "@/entities/game/model/gameLayout";
import {CONSUMABLE_EFFECTS} from "@/entities/effects/types";
import {IBought} from "@/entities/user/types";

export class InventoryStore {

    constructor(private rootStore: RootStore) {
        makeAutoObservable(this);
    }


    private get userStore() {
        return this.rootStore.userStore;
    }
    private get gameStore() {
        return this.rootStore.gameStore;
    }
    private get luckyStore() {
        return this.rootStore.luckyStore;
    }
    private get effectsStore() {
        return this.rootStore.effectsStore;
    }

    private get errorStore() {
        return this.rootStore.errorStore;
    }

    inventoryItems: Inventory = {};
    inventoryLimitItems: InventoryLimit = {};
    activeConsumables: Record<string, number> = {};
    loading: boolean = false;

    getInventory = async () => {
        this.loading = true;
        try {
            const inventory = await fetchInventory();
            if (inventory.success) {
                runInAction(() => {
                    this.inventoryItems = inventory.data;
                });
            } else {
                this.errorStore.setError(inventory.error);
            }
        } finally {
            runInAction(() => {
                this.loading = false;
            });
        }
    }
    getInventoryLimits = async () => {
        this.loading = true;
        try {
            const inventoryLimits = await fetchInventoryLimits();
            if (inventoryLimits.success) {
                runInAction(() => {
                    this.inventoryLimitItems = inventoryLimits.data;
                });
            } else {
                this.errorStore.setError(inventoryLimits.error);
            }
        } finally {
            runInAction(() => {
                this.loading = false;
            });
        }
    }

    activateConsumable(id: string) {
        if(this.inventoryLimitItems[id]?.limit == 0) return;
        const inventoryItem = this.inventoryItems[id];

        if (!inventoryItem.hitsDuration) return;

        this.activeConsumables[id] = inventoryItem.hitsDuration;

        const effect = CONSUMABLE_EFFECTS[id];
        if (effect) {
            this.effectsStore.enableEffect({
                id: id,
                type: effect.type,
                value: effect.value,
                target: effect.target,
            });

            this.inventoryLimitItems[id].limit -=1;
        }
    }
    activateConsumables(items: IBought){
        Object.entries(items).forEach(([id, item]) => {
            if(!item.remainingHits) return null;
            this.activeConsumables[id] = item.remainingHits;

            const effect = CONSUMABLE_EFFECTS[id];
            if (effect) {
                this.effectsStore.enableEffect({
                    id: id,
                    type: effect.type,
                    value: effect.value,
                    target: effect.target,
                });
            }
        });
    }


    // giveInventoryItem(id:string){
    //     if(this.inventoryLimitItems[id]?.limit == 0) return;
    //
    //     console.log('Дать приз')
    //
    //     this.inventoryLimitItems[id].limit -=1;
    // }


    onHitStreakChanged(streak: number) {
        if (streak === 10) {
            this.activateConsumable(InventoryItemsName.OviFlex100);
        }
        // if(streak === 6) {
        //     this.luckyStore.addRawWheel(1);
        // }
        // if(streak === 7) {
        //     this.activateConsumable(InventoryItemsName.EmptyNet10);
        // }
        // if(streak === 12) {
        //     this.activateConsumable(InventoryItemsName.EmptyNet25);
        // }

        if(streak == 10 && streak + this.userStore.dailyEnergy >= 10){
            this.gameStore.addRawScore(50);
        }
        if(streak == 15 && streak + this.userStore.dailyEnergy >= 15){
            this.gameStore.addRawScore(100);
        }


        //На сервере автоматом апгрейдится аптечка при первых 16 попадании
        // if(streak == 16 && streak + this.userStore.dailyEnergy >= 16){
        //     this.giveInventoryItem(InventoryItemsName.AidKit);
        // }

        if(streak == 20 && streak + this.userStore.dailyEnergy >= 20){
            this.gameStore.addRawScore(200);
        }

    }

    onHit(): Record<string, boolean> {
        const effectsChanged: Record<string, boolean> = {};

        const has10 = this.activeConsumables.hasOwnProperty(InventoryItemsName.EmptyNet10);
        const has25 = this.activeConsumables.hasOwnProperty(InventoryItemsName.EmptyNet25);

        let targetId: string | null = null;

        if (has10) {
            targetId = InventoryItemsName.EmptyNet10;
        } else if (has25) {
            targetId = InventoryItemsName.EmptyNet25;
        }

        Object.entries(this.activeConsumables).forEach(([id, hits]) => {
            if (
                (id === InventoryItemsName.EmptyNet10 || id === InventoryItemsName.EmptyNet25) &&
                id !== targetId
            ) {
                return;
            }

            const newHits = hits - 1;

            if (newHits <= 0) {
                delete this.activeConsumables[id];
                this.effectsStore.disableEffect(id);
                effectsChanged[id] = true;
            } else {
                this.activeConsumables[id] = newHits;
            }
        });

        this.userStore.decrementDailyEnergy();

        return effectsChanged;
    }






}
